"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformFile = void 0;
var identity_1 = require("./identity");
exports.transformFile = identity_1.identity;
exports.default = (function () { return new FormData(); });
